// extracted by mini-css-extract-plugin
export default {"r_l":"c37b95c6f6 _5ce0d880f3","t":"_2d197a440f"};